/**
 * Константы модуля сканера. Величины подобраны предположительно и уточняются
 * на площадке — разбор в docs/scanner-rewrite.md.
 */

// Запрет повторной отправки одного и того же кода, мс. Защита от бейджа,
// залипшего в кадре: буфер чтений отвечает за верность кода, а этот интервал —
// за то, что один бейдж не уедет на сервер дважды.
//
// Пять, а не тридцать, как стояло сначала. Отсчёт идёт от приёма кода и
// повторными чтениями не сдвигается, поэтому весь интервал бейдж в кадре
// держит рамку оранжевой — и столько же ждёт тот, кто поднёс тот же бейдж
// намеренно. Пяти секунд защите хватает: залипший бейдж даёт двенадцать
// записей в минуту вместо двух в секунду.
export const RESCAN_INTERVAL = 5000;

// Простой до снятия блокировки экрана, мс. У Wake Lock нет параметра
// длительности, поэтому таймер наш.
export const WAKE_LOCK_IDLE = 60000;

// Сколько результатов помнит история.
export const HISTORY_SIZE = 20;

// Сколько плашка результата держится поверх кадра, мс. Отсчёт начинается
// заново на каждом новом результате.
export const RESULT_HOLD = 20000;

// Сколько кодов уходит одним пакетом. Предела на стороне сервера нет —
// величина наша: на слабой связи короткий запрос уходит вернее, и меньше
// неизвестности, что дошло, а что нет.
export const QUEUE_BATCH = 20;

// Пауза до повторной попытки отправки и её потолок, мс. Пауза удваивается на
// каждой неудаче: связь на площадке пропадает надолго, и стучаться в сервер
// раз в полминуты до конца смены незачем.
export const RETRY_START = 30000;
export const RETRY_MAX = 300000;

// Что умеет декодер. Список не настройка, а решето: имя формата из конфига
// мероприятия, которого здесь нет, до POSSIBLE_FORMATS не доходит — незнакомое
// значение уронило бы декодер.
export const AVAILABLE_FORMATS = [
  'EAN_13',
  'EAN_8',
  'CODE_128',
  'CODE_39',
  'QR_CODE',
  'DATA_MATRIX',
];

// Набор на случай, когда мероприятие своего не отдало: бейджи печатаются с
// EAN-13 у большинства организаторов.
export const DEFAULT_FORMATS = ['EAN_13'];

// Мероприятие отдаёт допустимые форматы в config.json, поле scanner.formats.
export const FORMATS_API_READY = true;

// Кому доступен сканер. Значение приходит в userData.role с профилем.
// Список локальный намеренно: состав ролей у клиентов различается и правится
// в клиентской ветке — там же, где вырезаются модули.
export const SCANNER_ALLOWED_ROLES = ['exhibitor'];

// Ключи хранилища. Очередь досталась от прежней версии, менять её нельзя:
// на неё завязан быстрый вход по ссылке (docs/fast-login.md).
export const queueKey = (exhId) => `exh-${exhId}-scanner`;
export const historyKey = (exhId) => `exh-${exhId}-scanner-history`;
export const FORMATS_KEY = 'scanner-formats';
export const MUTED_KEY = 'scanner-muted';
export const CAMERA_KEY = 'camera-device';

// Чужие ключи, которые модуль только читает: конфиг мероприятия кладёт сюда
// getConfig, список мероприятий — getEventsList. Читаем хранилище, а не стор,
// чтобы не заводить ради одного модуля строку в общем коде: при вырезании под
// клиента её пришлось бы помнить отдельно.
export const configKey = (exhId) => `exhID-${exhId}-config`;
export const EVENT_LIST_KEY = 'event-list';

// Отладочные инструменты — выбор типов кодов и сброс хранилища. Нужны, чтобы
// подобрать настройки на площадке; в релизной сборке их быть не должно.
// Значение считается на сборке: production их не собирает вовсе, dev-сервер и
// serve-https показывают.
export const DEBUG_TOOLS = process.env.NODE_ENV !== 'production';

// Очередь узнаётся строго по этому виду. Просто «начинается с exh- и содержит
// scanner» нельзя: под него попадёт и история, а её отправлять некуда.
export const QUEUE_KEY_PATTERN = /^exh-(\d+)-scanner$/;

// Кому показывать вход в сканер. Один источник правды и для плитки в профиле,
// и для проверки на самом экране — иначе они разъедутся, и плитка окажется
// видна тому, кого экран не пустит.
//
// Отладочного послабления здесь нет намеренно: роли известны, и правило должно
// проверяться в разработке ровно так же, как у клиента.
//
// Это правило про облик, а не про безопасность: доступ к данным решает сервер,
// а мы всего лишь не показываем человеку то, чем он не может пользоваться.
export const canUseScanner = (role) => SCANNER_ALLOWED_ROLES.includes(role);
